import axios from './axios-auth'

const postContactMessage = async (request) => {
  try {
    const resp = await axios({
      url: '/me/contact',
      data: request,
      method: 'POST'
    })

    return resp;

  }
  catch (e) {
    console.error(e)
    return e
  }
}
export { postContactMessage }
